import Component from 'vue-class-component';
import { ContactListElementAbstract } from '../ContactAbstract/ContactListElementAbstract';

@Component({
})
export default class ContactTableElement extends ContactListElementAbstract {

}